/* Warm only browsing destinations the shopper indicates. Native navigation and
   checkout submissions remain responsible for currency, cart and form state. */
(() => {
  const warmed = new Set();
  let checkoutWarmed = false;

  function warmDocument(href) {
    if (!href || warmed.has(href)) return;
    warmed.add(href);
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({
        prefetch: [{ source: 'list', urls: [href], eagerness: 'moderate' }]
      });
      document.head.appendChild(rules);
    } else {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }
  }

  function warmLink(event) {
    const connection = navigator.connection;
    if (document.readyState !== 'complete' || document.visibilityState === 'hidden' ||
        connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '') ||
        warmed.size >= 6 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.hasAttribute('download') ||
        (anchor.target && anchor.target !== '_self') ||
        anchor.matches('[aria-controls], [data-no-prefetch], [data-subcat-tag], [data-category-clear]') ||
        anchor.closest('facet-link')) return;
    let url;
    try { url = new URL(anchor.href, location.href); } catch { return; }
    if (url.origin !== location.origin || url.username || url.password ||
        !/\/(products|collections)\/[^/]+\/?$/.test(url.pathname) ||
        [...url.searchParams.keys()].some((key) => key !== 'variant') ||
        (url.pathname === location.pathname && url.search === location.search)) return;
    url.hash = '';
    warmDocument(url.href);
  }

  function warmCheckout() {
    if (checkoutWarmed || document.readyState !== 'complete') return;
    checkoutWarmed = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const href = `${root.replace(/\/?$/, '/')}checkout`;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  }

  function warmCheckoutIntent(event) {
    const target = event.target?.closest?.(
      '[name="checkout"], button[name="checkout"], [formaction*="checkout"], a[href*="/checkout"]'
    );
    if (target) warmCheckout();
  }

  document.addEventListener('pointerover', warmLink, { passive: true });
  document.addEventListener('pointerdown', warmLink, { passive: true });
  document.addEventListener('focusin', warmLink);
  document.addEventListener('pointerover', warmCheckoutIntent, { passive: true });
  document.addEventListener('pointerdown', warmCheckoutIntent, { passive: true });
  document.addEventListener('focusin', warmCheckoutIntent);

  // Homepage / collection cart drawer → checkout
  document.addEventListener('toggle', (event) => {
    const drawer = event.target;
    if (drawer?.id === 'cart-drawer' && drawer.open) warmCheckout();
  }, true);
})();
